import BulkOperationsBar from './BulkOperationsBar';

export default BulkOperationsBar;
